<template>
    <div class="o-t-land-transport-schedule">
        <div
            v-for="(platform, i) in schedule"
            :key="platform.routeId + i"
            class="o-t-land-transport-schedule__item"
        >
            <div
                v-if="platform.number"
                class="o-t-land-transport-schedule__item-title"
            >
                Plattform {{platform.number}}
            </div>
            <div class="o-t-land-transport-schedule__item-platform">
                <div class="o-t-land-transport-schedule__item-platform-number">
                    {{ platform.route }}
                </div>
                <div class="o-t-land-transport-schedule__item-platform-name">
                    {{ platform.destination }}
                </div>
            </div>
            <div class="o-t-land-transport-schedule__item-time">
                <div class="o-t-land-transport-schedule__item-time-how">
                    {{ platform.nearest }}
                </div>
                <div class="o-t-land-transport-schedule__item-time-times">
                    <span
                        v-for="platform in platform.times"
                        :key="platform.id"
                    >
                        {{ platform.slot }}
                    </span>
                </div>
            </div>
            <template v-if="false">
                <div
                    class="o-t-land-transport-schedule__item-warning"
                    v-for="(platform, index) in platform.warnings"
                    :key="index"
                >
                    <div class="o-t-land-transport-schedule__item-warning-symbol" />
                    <span class="o-t-land-transport-schedule__item-warning-message">
                        {{ platform }}
                    </span>
                </div>
            </template>
            <div
                class="o-t-land-transport-schedule__item-directions"
                @click="goToGuide(platform.parentObject)"
            >
                {{$t('ui.terminal.directions', 'veibeskrivelse')}}
            </div>
        </div>
    </div>
</template>

<script>
import { getNewId } from "@/utils/services/core-service";
import {FAST} from "@/utils/constants/app-constants";
import {TERMINAL_STANDARD_GUIDE} from '@/utils/constants/pages'

export default {
    name: 'OTLandTransportSchedule',
    props: {
        transports: {
            type: Array,
            required: true
        }
    },
    computed: {
        schedule() {
            const preparedData = this.transports.map(transport => {
                const startIndex = transport.convertedTimeSlots ? 1 : 0;
                const times = transport.times.slice(startIndex, 5).map(slot => {
                    return {
                        slot: transport.convertedTimeSlots ? slot : this.$moment(slot).format("H:mm"),
                        id: getNewId()
                    }
                });

                const isWarnings = Boolean(transport?.warnings?.length);
                const nearest = transport.times[0] && !transport.convertedTimeSlots
                    ? this.formatNearestTime(transport.times[0])
                    : transport.times[0];

                return {
                    ...transport,
                    nearest,
                    isWarnings,
                    times
                }
            })

            return preparedData
        }
    },
    methods: {
        formatNearestTime(time) {
            const t = this.$moment(time);
            return (t > this.$moment().add(1, "hour"))
                ? t.format("H:mm")
                : Math.round(this.$moment.duration(t.diff(this.$moment())).asMinutes()) + " min";
        },
        goToGuide(object) {
            this.$router.push({
                name: TERMINAL_STANDARD_GUIDE,
                params: {
                    itemId: object.id,
                    mode: FAST
                }
            })
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />